<template>
  <div class="p-3 pl-4">
    <div class="vertical-line" v-for="(item, index) in logs" :key="index">
      <div class="circle">
        <div class="dot"></div>
      </div>
      <div class="pl-3 content-log">
        <div class="d-flex align-items-center mb-1 text-blue-400">
          <i
            :class="[
              'fa',
              'mr-2',
              method == 'COUNTER' ? 'fa-clock-o' : 'fa-calendar-alt',
            ]"
            style="font-size: 18px"
          ></i>
          <p class="text-sm mb-0" style="font-weight: 500">
            <template v-if="method == 'COUNTER'">
              {{ formatNumber(item?.extra_hours) }} Hours
            </template>
            <template v-else>
              {{
                item?.extra_date
                  ? moment(item?.extra_date).format('DD/MM/YYYY')
                  : '-'
              }}
            </template>
          </p>
        </div>
        <small class="text-black">{{ item.reason }}</small>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  props: {
    logs: {
      type: Array,
      default: () => [],
    },
    method: {
      type: String,
      default: 'CALENDAR',
    },
  },
  data() {
    return {
      moment,
    }
  },
  methods: {
    formatNumber(val) {
      if (val === null || val === undefined) return '-'
      return new Intl.NumberFormat('id-ID').format(val)
    },
  },
}
</script>
<style scoped>
.vertical-line {
  border-left: 2.4px solid #e5e7eb;
  min-height: 80px;
  position: relative;
}
.circle {
  width: max-content;
  border: 1.5px solid #1f48aa;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  padding: 4px;
  position: absolute;
  left: -10px;
  top: 4px;
}
.dot {
  width: 8px;
  height: 8px;
  background: #1f48aa;
  border-radius: 50%;
}
.text-blue-400 {
  color: #334697;
}
</style>
